module.exports = "<app-storyboard-header [storyboard]=\"storyboard\" (change)=\"change($event)\"></app-storyboard-header>\n<app-viewer-content *ngIf=\"file\" [file]=\"file\"></app-viewer-content>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/storyboard/storyboard.component.html
// module id = ./src/app/views/storyboard/storyboard.component.html
// module chunks = main